import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TableService } from '@morningstar/shared/base/base-service';
import { Search } from './search';

@Injectable()
export class SearchBarService extends TableService<Search> {

  dataDescription: 'search result';

  constructor(httpClient: HttpClient,
              snackbar: MatSnackBar,
              @Inject('API_BASE_URL') baseUrl: string) {
    super(snackbar, httpClient, baseUrl);
  }

  getMatches(searchText: string) {
    const endpoint = `shared/search/${searchText}`;
    return this.read<Search>('search', endpoint);
  }

  saveSearch(search: Search) {
    const endpoint = `shared/search`;
    return this.create(search, endpoint, null).subscribe();
  }
}
